import { useEffect } from 'react';

export const useUpdateEmailShareLink = (headline: string) => {
  useEffect(() => {
    const pageURL = window.location.href;
    const shareIcons = document.querySelector('[data-testid="article-social-media-icons"]');
    if (!shareIcons) return;

    const emailAnchor = shareIcons.querySelector<HTMLAnchorElement>('a[title="Envelope"]');
    if (!emailAnchor) return;

    const currentHref = emailAnchor.getAttribute('href');
    if (!currentHref) return;

    const updateEmailHref = () => {
      const updatedHref = currentHref
        .replace('{subject}', encodeURIComponent(headline))
        .replace('{body}', encodeURIComponent(pageURL));

      emailAnchor.setAttribute('href', updatedHref);
    };

    updateEmailHref();

    const observer = new MutationObserver(() => {
      updateEmailHref();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [headline]);
};
